import Header from "./Header";
import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { isAdmin } from './services/apiClient';

// Previously this only checked whether *any* 'user-info' key existed in
// localStorage - any logged-in user (or anyone who pastes a fake object into
// localStorage via devtools) could reach admin pages. It also didn't matter
// server-side, since the underlying API endpoints had no auth either.
// The API endpoints are now locked down (routes/api.php: auth:sanctum +
// admin middleware) - this client-side check is just for UX (don't flash
// the admin UI at non-admins); the real enforcement is on the server.
function Protected(props) {
  let Cmp = props.Cmp;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin()) {
      navigate('/login');
    }
  }, []);

  return (
    <div>
      <Cmp />
    </div>
  );
}

export default Protected;
